import { FormlyFieldConfig } from '@ngx-formly/core';

// Step 1: only the Loan Number, used to look up the existing loan
export function getLoanNumberFields(customFieldClass: string): FormlyFieldConfig[] {
    return [
        {
        className: 'col-12',
        fieldGroupClassName: 'row',
        fieldGroup: [
        {
          key: 'NLSLoanNumber',
          type: 'input',
          className: customFieldClass,
          props: {
            label: 'Loan Number',
            appearance: 'outline',
            floatLabel: 'always',
            required: true,
          },
        },
      ]
    },
  ]
}

// Step 2: the loan details, pre-populated from the loan found in step 1
export function getLoanDetailsFields(
  maxCalendarDate: string | Date,
  customFieldClass: string): FormlyFieldConfig[] {
    // Executed Date on its own row, Principal Amount + Interest Rate on the next
    const colClass = (col: string) => customFieldClass.replace(/\bcol-12\b/, col);
    return [
        {
        className: 'col-12',
        fieldGroupClassName: 'row',
        fieldGroup: [
        {
          key: 'NLSOpenDate',
          type: 'datepicker',
          className: customFieldClass,
          props: {
            label: 'Executed Date',
            appearance: 'outline',
            floatLabel: 'always',
            required: true,
            datepickerOptions: {
              max: maxCalendarDate
            }
          },
        },
        {
          key: 'NLSPrincipalAmount',
          type: 'currency',
          className: colClass('col-12 col-md-6 pe-md-1'),
          props: {
            label: 'Principal Amount',
            appearance: 'outline',
            floatLabel: 'always',
            subscriptSizing: 'fixed',   // reserve error space like the other fields so the dialog height doesn't change
            required: true,
          },
          validators: {
            positive: {
              expression: (c: { value: unknown }) =>
                Number(String(c.value ?? '').replace(/,/g, '')) > 0,
              message: () => 'Principal Amount must be greater than zero',
            },
          },
        },
        {
          key: 'NLSInterestRate',
          type: 'input',
          className: colClass('col-12 col-md-6 ps-md-1'),
          props: {
            label: 'Interest Rate',
            appearance: 'outline',
            floatLabel: 'always',
            required: true,
            type: 'number',
            min: 0,
            max: 100,
            step: 0.01,
          },
        },
      ]
    },
  ]
}
